import { FormProvider, useForm } from "react-hook-form"
import { UsageType, usageValidation } from "../../utils"
import { FormUsage } from "../FormSection"
import { yupResolver } from "@hookform/resolvers/yup"
import { useContext, useEffect } from "react"
import { FormDataContext } from "../../context"
import { defaultValueUsage } from "../../utils/vars"
import toast from "react-hot-toast"
import { useApi } from "utils"

export function TabUsage() {
    const api = useApi()

    const { dataUsage, refecthUsage, dataAsset } = useContext(FormDataContext)

    const method = useForm<UsageType>({
        defaultValues: defaultValueUsage(dataUsage ?? {}),
        resolver: yupResolver(usageValidation),
    })

    useEffect(() => {
        if (dataAsset) {
            method.reset(defaultValueUsage(dataUsage));
        }
        // eslint-disable-next-line
    }, [dataAsset, method.reset]);


    const onSubmit = (data: UsageType) => {

        return new Promise<void>((resolve) => {
            toast.promise(
                api.post(`/assetdepre/save_disposal`, null, {
                    params: {
                        asset_id: dataAsset?.asset_id,
                        coa_asset_id: data.coa_asset_id,
                        coa_disposal_id: data.coa_disposal_id,
                        net_book_value: data.net_book_value,
                        memo: data.memo,
                        disposal_date: data.date_disposal
                    }
                }),

                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            ).then(() => {

                refecthUsage()

                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                }, 100);

            }).catch(() => { }).finally(resolve)
        })
    }

    return (
        <FormProvider {...method}>
            <FormUsage onSubmit={method.handleSubmit(onSubmit)} />
        </FormProvider>
    )
}